import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTitleBankList(data) {
  return request({
    url: URL.partner.getTitleBank,
    method: 'post',
    data: data
  })
}

export function getTitleBankDetailList(params) {
  return request({
    url: URL.partner.titleBankDetail,
    method: 'get',
    params
  })
}

export function saveTitleBank(data) {
  return request({
    url: URL.partner.titleBank,
    method: data.uuid || (data.uuidList && data.uuidList.length > 0) ? 'put' : 'post',
    data
  })
}

export function delTitleBank(uuid) {
  return request({
    url: URL.partner.titleBank + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function allTitleBanksByCmpIdx(companyId) {
  return request({
    url: URL.partner.allTitleBanksByCmpIdx + '?companyId=' + encodeURIComponent(companyId),
    method: 'get'
  })
}

// 合作伙伴开票抬头&银行信息新增/补全
export function upsertPartnerTitleBank(data) {
  return request({
    url: URL.partner.upsertPartnerTitleBank,
    method: 'post',
    data
  })
}

// 开票抬头银行保存操作
export function saveTitleBankOperate(data) {
  return request({
    url: URL.partner.saveTitleBankOperate,
    method: 'post',
    data
  })
}
